import { Fragment } from 'react'
import { CASHTAG_CLASS, splitCashtags } from '@/components/cashtag-highlight'

/**
 * Plain text with ticker symbols rendered as highlighted `$SYMBOL` chips —
 * the user-bubble counterpart of the assistant markdown's rehypeCashtags.
 */
export function TickerText({ text, known }: { text: string; known?: ReadonlySet<string> }) {
  const tokens = splitCashtags(text, known)
  return (
    <>
      {tokens.map((token, i) =>
        token.type === 'ticker' ? (
          <span key={i} className={CASHTAG_CLASS}>
            {token.text}
          </span>
        ) : (
          <Fragment key={i}>{token.text}</Fragment>
        ),
      )}
    </>
  )
}
